<template>
  <div>
    <main class="main-content">
      <div class="page-content">
        <div class="container">
          <div class="lds-ring" v-if="!isLoad">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <section class="section-hotels-edit-hotel" v-if="isLoad">

            <div class="hotels-wrap">
              <div class="hotel-inner-edit">
                <form>
                  <div class="page-title">
                    <h2>Hotel</h2>
                  </div>
                  <div class="hotel-name-edit">
                    <div :class="['form-control-group', {'is-error' : errors.hotel}]"><span class="form-control-label">Hotel Name</span>
                      <div :class="['select-wrapper select-wrapper_hotel-name', {'is-active' : selects.hotel}]"
                           @click="openSelect('hotel');errors.hotel = false">
                        <div class="select-trigger"><span
                            class="select-trigger__name">{{ data.hotels.find(item => item.id === dataHotel.altezzaHotelId) ? data.hotels.find(item => item.id === dataHotel.altezzaHotelId).title : 'Select' }}</span><span
                            class="select-trigger__icon">
                                        <svg width="1em" height="1em" class="icon icon-chevron ">
                                            <use
                                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                                        </svg></span></div>
                        <div class="select-body">
                          <div class="select-inner">
                            <div
                                v-for="item in data.hotels"
                                :key="item.id"
                                :class="['select-option', {'is-selected' : item.id === dataHotel.altezzaHotelId}]"
                                @click="dataHotel.altezzaHotelId = item.id;dataHotel.locationId = null;dataHotel.territoryId = null;dataHotel.areaId = null">
                              <span class="select-option__name">{{ item.title }}</span></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="line-cols line-cols_edit-htl">
                    <div :class="['form-control-group', {'is-error' : errors.territory}]"><span
                        class="form-control-label">Territory</span>
                      <div
                          :class="['select-wrapper', {'is-active' : selects.territory}]"
                          @click="openSelect('territory');errors.territory = false"
                          :style="{opacity: !dataHotel.altezzaHotelId  ? .6 : 1, cursor: !dataHotel.altezzaHotelId ? 'default' : 'pointer', pointerEvents: !dataHotel.altezzaHotelId ? 'none' : 'auto'}"
                      >
                        <div class="select-trigger"><span
                            class="select-trigger__name">{{ data.territories.find(item => item.id === dataHotel.territoryId) ? data.territories.find(item => item.id === dataHotel.territoryId).title : 'Select' }}</span><span
                            class="select-trigger__icon">
                                        <svg width="1em" height="1em" class="icon icon-chevron ">
                                            <use
                                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                                        </svg></span></div>
                        <div class="select-body">
                          <div class="select-inner">
                            <div
                                v-for="item in data.territories"
                                :key="item.id"
                                :class="['select-option', {'is-selected' : item.id === dataHotel.territoryId}]"
                                @click="dataHotel.territoryId = item.id;dataHotel.locationId = null;dataHotel.areaId = null">
                              <span class="select-option__name">{{ item.title }}</span></div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div :class="['form-control-group', {'is-error' : errors.location}]"><span
                        class="form-control-label">Location</span>
                      <div
                          :class="['select-wrapper', {'is-active' : selects.location}]"
                          @click="openSelect('location'); errors.location = false"
                          :style="{opacity: !dataHotel.altezzaHotelId || !dataHotel.territoryId || !data.locations.filter(item => item.territory.id === dataHotel.territoryId).length ? .6 : 1, cursor: !dataHotel.altezzaHotelId || !dataHotel.territoryId || !data.locations.filter(item => item.territory.id === dataHotel.territoryId).length  ? 'default' : 'pointer', pointerEvents: !dataHotel.altezzaHotelId || !dataHotel.territoryId || !data.locations.filter(item => item.territory.id === dataHotel.territoryId).length  ? 'none' : 'auto'}"
                      >
                        <div class="select-trigger"><span
                            class="select-trigger__name">{{ data.locations.find(item => item.location.id === dataHotel.locationId) ? data.locations.find(item => item.location.id === dataHotel.locationId).location.title : 'Select' }}</span><span
                            class="select-trigger__icon">
                                        <svg width="1em" height="1em" class="icon icon-chevron ">
                                            <use
                                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                                        </svg></span></div>
                        <div class="select-body">
                          <div class="select-inner" v-if="dataHotel.territoryId">
                            <div
                                v-for="item in data.locations.filter(item => item.territory.id === dataHotel.territoryId)"
                                :key="item.location.id"
                                :class="['select-option', {'is-selected' : item.location.id === dataHotel.locationId}]"
                                @click="dataHotel.locationId = item.location.id;dataHotel.areaId = null"><span
                                class="select-option__name">{{ item.location.title }}</span></div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div :class="['form-control-group', {'is-error' : errors.area}]"><span class="form-control-label">Area</span>
                      <div
                          :class="['select-wrapper', {'is-active' : selects.area}]"
                          @click="openSelect('area');errors.area = false"
                          :style="{opacity: !dataHotel.altezzaHotelId  || !dataHotel.territoryId || !dataHotel.locationId || !data.areas.filter(item => item.territory.id === dataHotel.territoryId && item.location.id ===  dataHotel.locationId).length  ? .6 : 1, cursor: !dataHotel.altezzaHotelId || !dataHotel.territoryId  || !dataHotel.locationId   || !data.areas.filter(item => item.territory.id === dataHotel.territoryId && item.location.id ===  dataHotel.locationId).length ? 'default' : 'pointer', pointerEvents: !dataHotel.altezzaHotelId || !dataHotel.territoryId  || !dataHotel.locationId  || !data.areas.filter(item => item.territory.id === dataHotel.territoryId && item.location.id ===  dataHotel.locationId).length  ? 'none' : 'auto'}"
                      >
                        <div class="select-trigger"><span
                            class="select-trigger__name">{{ data.areas.find(item => item.area.id === dataHotel.areaId) ? data.areas.find(item => item.area.id === dataHotel.areaId).area.title : 'Select' }}</span><span
                            class="select-trigger__icon">
                                        <svg width="1em" height="1em" class="icon icon-chevron ">
                                            <use
                                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                                        </svg></span></div>
                        <div class="select-body">
                          <div class="select-inner" v-if="dataHotel.locationId">
                            <div
                                v-for="item in data.areas.filter(item => item.territory.id === dataHotel.territoryId && item.location.id ===  dataHotel.locationId)"
                                :key="item.area.id"
                                :class="['select-option', {'is-selected' : item.area.id === dataHotel.areaId}]"
                                @click="dataHotel.areaId = item.area.id"><span
                                class="select-option__name">{{ item.area.title }}</span></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="hotel-language">
                    <div class="form-control-label">Description</div>
                    <div class="languages-group">
                      <label class="np-detail-collapse__lang np-detail-collapse__lang_checkbox"
                             @click="descriptionLang = 'EN'">
                        <input type="radio" name="lanuage" @click.prevent :checked="descriptionLang === 'EN'">
                        <div class="np-detail-collapse__lang__icon">
                          <svg width="1em" height="1em" class="icon icon-gb ">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-gb"></use>
                          </svg>
                        </div>
                        <span class="np-detail-collapse__lang__text">English</span>
                      </label>
                      <label class="np-detail-collapse__lang np-detail-collapse__lang_checkbox"
                             @click="descriptionLang = 'RU'">
                        <input type="radio" name="lanuage" :checked="descriptionLang === 'RU'">
                        <div class="np-detail-collapse__lang__icon">
                          <svg width="1em" height="1em" class="icon icon-rus ">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-rus"></use>
                          </svg>
                        </div>
                        <span class="np-detail-collapse__lang__text">Russian</span>
                      </label>
                      <label class="np-detail-collapse__lang np-detail-collapse__lang_checkbox"
                             @click="descriptionLang = 'DE'">
                        <input type="radio" name="lanuage" :checked="descriptionLang === 'DE'">
                        <div class="np-detail-collapse__lang__icon">
                          <svg width="1em" height="1em" class="icon icon-deu ">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-deu"></use>
                          </svg>
                        </div>
                        <span class="np-detail-collapse__lang__text">Deutch</span>
                      </label>
                    </div>
                  </div>
                  <div class="form-control-group group-edit-desc">
                    <div class="form-control-wrap">
                      <div class="js-ckeditor">
                        <editor :editor="editor" v-model="dataHotel.info[descriptionLang].description"
                                @input="isEditFlag = true" :config="editorConfig"></editor>
                      </div>
                    </div>
                  </div>
                  <div class="hotel-language">
                    <div class="form-control-label">Additional Notes</div>
                    <div class="languages-group">
                      <label class="np-detail-collapse__lang np-detail-collapse__lang_checkbox"
                             @click="notesLang = 'EN'">
                        <input type="radio" name="lanuage" @click.prevent :checked="notesLang === 'EN'">
                        <div class="np-detail-collapse__lang__icon">
                          <svg width="1em" height="1em" class="icon icon-gb ">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-gb"></use>
                          </svg>
                        </div>
                        <span class="np-detail-collapse__lang__text">English</span>
                      </label>
                      <label class="np-detail-collapse__lang np-detail-collapse__lang_checkbox"
                             @click="notesLang = 'RU'">
                        <input type="radio" name="lanuage" @click.prevent :checked="notesLang === 'RU'">
                        <div class="np-detail-collapse__lang__icon">
                          <svg width="1em" height="1em" class="icon icon-rus ">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-rus"></use>
                          </svg>
                        </div>
                        <span class="np-detail-collapse__lang__text">Russian</span>
                      </label>
                      <label class="np-detail-collapse__lang np-detail-collapse__lang_checkbox"
                             @click="notesLang = 'DE'">
                        <input type="radio" name="lanuage" @click.prevent :checked="notesLang === 'DE'">
                        <div class="np-detail-collapse__lang__icon">
                          <svg width="1em" height="1em" class="icon icon-deu ">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-deu"></use>
                          </svg>
                        </div>
                        <span class="np-detail-collapse__lang__text">Deutch</span>
                      </label>
                    </div>
                  </div>
                  <div class="form-control-group group-edit-desc-2">
                    <div class="form-control-wrap">
                      <div class="js-ckeditor">
                        <editor :editor="editor" v-model="dataHotel.info[notesLang].additionalNotes"
                                @input="isEditFlag = true" :config="editorConfig2"></editor>
                      </div>
                    </div>
                  </div>


                  <div class="form-control-group line-cols_2_amenities">
                    <span class="hotel-subtitle">AMENITIES</span>
                    <div class="form-control-wrap">
                      <div class="group-checkboxes">
                        <label :class="['checkbox-square']" v-for="(item, index) in data.tags" :key="index"
                               @click.prevent="item.active = !item.active;errors.tag = false">
                          <input type="checkbox" @click.prevent :checked="item.active">
                          <span :class="['checkbox-square__label', {'is-error' : errors.tag}]">
                                                <svg width="1em" height="1em" :class="'icon icon-' + item.icon"><use
                                                    :xlink:href="'/images/useful/svg/theme/symbol-defs.svg#icon-' + item.icon"></use></svg>{{ item.name }}
                                            </span>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="form-control-group form-control-group_photo">
                    <div class="hotel-subtitle">Photo Gallery</div>


                    <div class="photo-hotel-add">
                      <div
                          v-for="(item, index) in dataHotel.photos"
                          :key="index"
                          class="form-control-photo-group form-control-photo-group--squared form-control-photo-group--visible-btn photo-hotel-add__item"
                      >
                        <div class="form-control-photo"><span class="form-control-photo__box h-object-fit">
                                                <img :src="`${API}/documents/share/images/${item}?size=LARGE`" alt="">
                                            </span>
                          <button type="button" class="btn btn--remove"
                                  @click="dataHotel.photos = dataHotel.photos.filter((_, i) => i === index ? false : true)">
                            <svg width="1em" height="1em" class="icon icon-close ">
                              <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                            </svg>
                          </button>
                        </div>
                      </div>


                      <div @click="$emit('changeImage', 'default')"
                           class="form-control-photo-group form-control-photo-group--squared form-control-photo-group--visible-btn photo-hotel-add__item">
                        <input type="file" id="photo_load" class="input-hidden">
                        <label for="photo_load1" class="form-control-photo"><span
                            class="form-control-photo__box h-object-fit"></span>
                          <button type="button" class="btn btn--plus">
                            <svg width="1em" height="1em" class="icon icon-plus">
                              <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-plus"></use>
                            </svg>
                          </button>
                        </label>
                      </div>
                    </div>


                    <div class="hotel-notes">Minimum image size: 1440 x 1080p
                      <div>Max 5 MB</div>
                    </div>

                  </div>

                  <div class="edit-rooms__btn-edit edit-hotels-btn">
                    <button type="button" class="btn btn--green"
                            @click="isEdit ? updateHotelHandler() : createHotelHandler()">
                      <span>{{ isEdit ? 'Update' : 'Save' }}</span></button>
                  </div>
                </form>
              </div>
            </div>


          </section>
        </div>
      </div>
    </main>
  </div>
</template>


<script>

import {
  getHotel,
  getHotelsAll,
  getTerritoriesAll,
  getLocationsAll,
  getAreasAll,
  createHotel,
  updateHotel,
  API
} from '@/utilites/api'

import CKEditor from '@ckeditor/ckeditor5-vue2'
import ClassicEditor from '@/utilites/ckeditor'

export default {
  data() {
    return {
      isLoad: false,
      hotel: null,
      isEdit: false,
      API: API,
      editor: ClassicEditor,
      isEditFlag: false,
      editorConfig: {
        placeholder: 'Write description'
      },
      editorConfig2: {
        placeholder: 'Write notes'
      },
      descriptionLang: 'EN',
      notesLang: 'EN',
      dataHotel: {
        "altezzaHotelId": null,
        "territoryId": null,
        "locationId": null,
        "areaId": null,
        "info": {
          "EN": {
            "description": "",
            "additionalNotes": ""
          },
          "RU": {
            "description": "",
            "additionalNotes": ""
          },
          "DE": {
            "description": "",
            "additionalNotes": ""
          }
        },
        "tags": [],
        "photos": []
      },
      data: {
        tags: [
          {
            name: 'WiFi',
            data: 'WIFI',
            active: false,
            icon: 'wifi'
          },
          {
            name: 'Swimming pool',
            data: 'SWIMMING_POOL',
            active: false,
            icon: 'pool'
          },
          {
            name: 'Laundry service',
            data: 'LAUNDRY',
            active: false,
            icon: 'laundry'
          },
          {
            name: 'Gym',
            data: 'GYM',
            active: false,
            icon: 'gym'
          },
          {
            name: 'Air Conditioner',
            data: 'CONDITIONER',
            active: false,
            icon: 'conditioner'
          },
          {
            name: 'Wildlife area',
            data: 'WILDLIFE_AREA',
            active: false,
            icon: 'wildlife'
          },
          {
            name: 'Spa',
            data: 'SPA',
            active: false,
            icon: 'spa'
          },
          {
            name: 'Restaurant',
            data: 'RESTAURANT',
            active: false,
            icon: ''
          }
        ],
        hotels: [],
        territories: [],
        locations: [],
        areas: []
      },
      selects: {
        hotel: false,
        territory: false,
        location: false,
        area: false,
      },
      errors: {
        hotel: false,
        territory: false,
        location: false,
        area: false,
        tag: false
      }
    }
  },
  components: {editor: CKEditor.component},
  props: ['uploadedFile'],
  mounted() {
    this.isEdit = this.$route.params.id
    getHotelsAll()
        .then(res => {
          this.data.hotels = res
          Promise.all([getTerritoriesAll(), getLocationsAll(), getAreasAll()])
              .then(res => {
                this.data.territories = res[0].map(item => ({...item, active: false}))
                this.data.locations = res[1].map(item => ({...item, active: false}))
                this.data.areas = res[2].map(item => ({...item, active: false}))
              })
        })
    window.addEventListener('click', event => {
      if (!event.target.closest('.select-wrapper')) {
        this.selects = {
          hotel: false,
          territory: false,
          location: false,
          area: false,
        }
      }
    })
    if (this.isEdit) {
      getHotel(this.isEdit)
          .then(res => {
            this.dataHotel = res
            this.data.tags = this.data.tags.map(item => ({...item, active: res.tags.includes(item.data)}))
            this.isLoad = true
          })
    } else {
      this.isLoad = true
    }
  },
  methods: {
    openSelect(name) {
      this.selects = {
        hotel: false,
        territory: false,
        location: false,
        area: false,
        [name]: !this.selects[name]
      }
    },
    checkErrors() {
      this.errors = {
        hotel: this.dataHotel.altezzaHotelId ? false : true,
        territory: this.dataHotel.territoryId ? false : true,
        location: this.dataHotel.locationId ? false : true,
        area: this.dataHotel.areaId ? false : true,
        tag: this.data.tags.find(item => item.active) ? false : true
      }
      let error = false
      for (const key in this.errors) {
        if (this.errors[key]) {
          error = true
        }
      }
      if (error) {
        window.scrollTo({top: 0})
      }
      return error
    },
    createHotelHandler() {
      if (!this.checkErrors()) {
        createHotel({
          ...this.dataHotel,
          tags: this.data.tags.filter(item => item.active).map(item => item.data)
        })
            .then(() => {
              this.$emit('confirmed')
              this.$router.push('/hotels')
            })
            .catch(() => {
              this.errors.hotel = true
              window.scrollTo({top: 0})
            })
      }
    },
    updateHotelHandler() {
      delete this.dataHotel.createdAt
      delete this.dataHotel.title
      delete this.dataHotel.updatedAt
      if (!this.checkErrors()) {
        updateHotel({
          ...this.dataHotel,
          tags: this.data.tags.filter(item => item.active).map(item => item.data)
        })
            .then(() => {
              this.$emit('confirmed')
              this.$router.push('/hotels')
            })
            .catch(() => {
              this.errors.hotel = true
              window.scrollTo({top: 0})
            })
      }
    }
  },
  watch: {
    uploadedFile() {
      if (this.uploadedFile) {
        this.dataHotel.photos = this.dataHotel.photos.concat(this.uploadedFile)
      }
    }
  }
}
</script>
